import { render, staticRenderFns } from "./LayoutPublicWideCpr.vue?vue&type=template&id=0bba5d12"
import script from "./LayoutPublicWideCpr.vue?vue&type=script&lang=js"
export * from "./LayoutPublicWideCpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports